import { createContext } from 'react';
import { AllToggles } from '../../api/services/UnleashController.ts';

export type UnleashToggleNames =
	| 'vegdim.vegdim-web.mekanistiskempirisk'
	| 'vegdim.vegdim-web.spordybde';
interface UnleashContextType {
	toggles: AllToggles[];
	isToggleEnabled: (toggleName: UnleashToggleNames) => boolean;
}

export const UnleashContext = createContext<UnleashContextType>({
	toggles: [],
	isToggleEnabled: (_) => false,
});
